<div class="table-row-wrapper" OnHold [holdDisabled]="!CrudRecordTypes.includes(row().type)" (onHold)="edit()" [ngClass]="{'active-l':activeL}" SwipeElement [swipeDisabled]="!CrudRecordTypes.includes(row().type)" (swipeLeft)="row().type !== 'sleep' ? swipeL() : undefined" (swipeRight)="row().type !== 'sleep' ? swipeR() : undefined">
	<app-table-row-base [hideIcon]="hideIcon()" [row]="row()"></app-table-row-base>
	<div class="table-row-content">
		@if (svcTableTools.rowComps[row().type] && row()) {
			<ng-container [ngComponentOutlet]="svcTableTools.rowComps[row().type]!" [ngComponentOutletInputs]="{row: row(), detailed: detailed()}"></ng-container>
		}
	</div>
	@if (CrudRecordTypes.includes(row().type)) {
		@if (activeL) {
			<div class="table-row-btns">
				@if (row().type !== 'food') {
					<div class="table-row-btn" (click)="copy()">
						<i class="fa-sharp fal fa-copy"></i>
					</div>
				}
				<div class="table-row-btn" (click)="delete()">
					<i class="fa-sharp fal fa-xmark-large"></i>
				</div>
			</div>
		}
	}
</div>